import React from "react";

const clampNumber = (value, min, max) => Math.min(Math.max(value, min), max);

const ProgressBar = ({
  numerator,
  denominator,
  title,
  subtitle,
  percentTextGenerator,
  grey = false,
  IconComponentClass,
  className = "",
  iconProps = {},
  "data-testid": dataTestId = "progress-bar",
}) => {
  const safeDenominator = Number.isFinite(denominator) ? Math.max(denominator, 0) : 0;
  const safeNumerator = Number.isFinite(numerator) ? Math.max(numerator, 0) : 0;
  const clampedNumerator = safeDenominator > 0 ? clampNumber(safeNumerator, 0, safeDenominator) : safeNumerator;
  const percentValue = safeDenominator > 0 ? (clampedNumerator / safeDenominator) * 100 : 0;
  const percentWidth = clampNumber(percentValue, 0, 100);
  const roundedPercent = Math.round(percentWidth);

  const trackClass = grey ? "bg-[#E6E7EB] dark:bg-[#2D3734]" : "bg-[#E6E7EB] dark:bg-[#1B3C2C]";
  const fillClass = grey ? "bg-[#C2CECA] dark:bg-[#7F8B86]" : "bg-[#01A453]";
  const backgroundClass = grey ? "" : "bg-white";

  const percentText = typeof percentTextGenerator === 'function' ? percentTextGenerator(roundedPercent) : `${roundedPercent}%`;

  const containerClass = `flex flex-col gap-4 rounded-xl p-5 dark:bg-transparent ${backgroundClass} ${className}`.trim();

  return (
    <div className={containerClass} data-testid={dataTestId}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-1">
          {IconComponentClass ? (
            <div className="flex size-11 items-center justify-center rounded-full">
              <IconComponentClass {...iconProps} />
            </div>
          ) : null}
          <p className="text-base font-semibold text-dark-grey dark:text-white">{title}</p>
        </div>
        <div className="flex flex-col items-end text-right text-dark-grey dark:text-white">
          <p className="text-2xl font-semibold leading-tight" data-testid={`${dataTestId}-count`}>
            {safeDenominator > 0 ? `${clampedNumerator}/${safeDenominator}` : clampedNumerator}
          </p>
          <p className="text-xs font-normal text-dark-grey/70 dark:text-white/70">
            {subtitle}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className={`h-2 w-full rounded-full ${trackClass}`}>
          <div
            className={`h-full rounded-full ${fillClass}`}
            style={{ width: `${percentWidth}%` }}
            data-testid={`${dataTestId}-fill`}
          ></div>
        </div>
        <p className="text-sm text-dark-grey/80 dark:text-white/80" data-testid={`${dataTestId}-percent`}>
          {percentText}
        </p>
      </div>
    </div>
  );
};

export default ProgressBar;
